import React, { Component } from 'react'
import { Button, Checkbox, Modal } from 'antd'
import UploadWithPopupPreview from '../UploadWithPopupPreview/UploadWithPopupPreview'
import _ from 'lodash'

import './GenerateWPReportModal.scss'

export default class GenerateWPReportModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            modalVisible: false,
            sections: [],
            noticeSection: []
        }

        this.handleClick = this.handleClick.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.handleConfirm = this.handleConfirm.bind(this)
        this.handleItemCheck = this.handleItemCheck.bind(this)
        this.handleNoticeItemCheck = this.handleNoticeItemCheck.bind(this)
    }

    handleClick() {
        this.setState({ modalVisible: true })
    }

    handleCancel() {
        this.setState({ modalVisible: false })
    }

    handleItemCheck(sectionIdx, itemIdx, e) {
        let newSections = _.cloneDeep(this.state.sections)

        newSections[sectionIdx].items[itemIdx].checked = true

        this.setState({ sections: newSections })
    }

    handleNoticeItemCheck(itemIdx, e) {
        let newnoticeSection = _.cloneDeep(this.state.noticeSection)

        newnoticeSection.items[itemIdx].checked = true

        this.setState({ noticeSection: newnoticeSection })
    }

    handleConfirm() {
        const { onConfirm } = this.props
        const { sections, noticeSection } = this.state
        let exportSections = [],
            exportnoticeSection = { items: [] }

        if (sections.length !== 0)
            _.forEach(sections, (section, sectionIdx) => {
                const { name, items } = section
                if (!_.isEmpty(_.find(items, 'checked'))) {
                    exportSections.push({ original_idx: sectionIdx, name, items: [] })
                    _.forEach(section.items, (item, itemIdx) => {
                        if (item.checked) {
                            const targetSection = _.find(exportSections, { original_idx: sectionIdx })
                            targetSection.items.push({ original_idx: itemIdx, ...item })
                        }
                    })
                }
            })

        if (!_.isEmpty(noticeSection) && !_.isEmpty(_.find(noticeSection.items, 'checked'))) {
            _.forEach(noticeSection.items, (item, itemIdx) => {
                if (item.checked) {
                    exportnoticeSection.items.push({ original_idx: itemIdx, ...item })
                }
            })
        }

        onConfirm(exportSections, exportnoticeSection)

        this.setState({ modalVisible: false })
    }

    componentDidUpdate(prevProps, prevState) {
        const { modalVisible } = this.state
        if (!_.isEqual(prevProps.sections, this.props.sections)) {
            this.setState({ sections: this.props.sections })
        }

        if (!_.isEqual(prevProps.noticeSection, this.props.noticeSection)) {
            this.setState({ noticeSection: this.props.noticeSection })
        }

        if (prevState.modalVisible !== modalVisible && modalVisible) {
            this.setState({ sections: this.props.sections, noticeSection: this.props.noticeSection })
        }
    }

    renderItemRow(sectionIdx, itemList) {
        return _.map(itemList, (item, itemIdx) => {
            const { name, imageUrl, progress, updated, checked } = item
            if (updated)
                return (
                    <tr key={`${sectionIdx}-${itemIdx}`}>
		                <td><Checkbox checked={checked} onChange={this.handleItemCheck.bind(this, sectionIdx, itemIdx)}/></td>
		                <td>{sectionIdx + 1}.{itemIdx + 1}</td>
		                <td>
		                    <div className="table-item">{name}</div>
		                </td>
		                <td>
		                    <UploadWithPopupPreview
		                        itemImageUrl={imageUrl}
		                        isLocked={true}
		                    />
		                </td>
		                <td>{progress}</td>
		            </tr>
                )
        })
    }

    renderNoticeItemRow(itemList) {
        return _.map(itemList, (item, itemIdx) => {
            const { name, imageUrl, progress, updated, checked } = item
            if (updated)
                return (
                    <tr key={`others-${itemIdx}`}>
		                <td><Checkbox checked={checked} onChange={this.handleNoticeItemCheck.bind(this, itemIdx)}/></td>
		                <td>{itemIdx + 1}</td>
		                <td>
		                    <div className="table-item">{name}</div>
		                </td>
		                <td>
		                    <UploadWithPopupPreview
		                        itemImageUrl={imageUrl}
		                        isLocked={true}
		                    />
		                </td>
		                <td>{progress}</td>
		            </tr>
                )
        })
    }

    renderSectionRow() {
        const { sections } = this.state

        if (sections.length !== 0)
            return _.map(sections, (section, sectionIdx) => (
                <div className="section" key={sectionIdx}>
                    <div className="section-header">
                        <div className="section-idx">{sectionIdx + 1}.0</div>
                        <div className="section-name">{section.name}</div>
                    </div>
                    <table className={`item-table${section.toggled ? ' toggled' : ''}`}>
                        <thead>
                            <tr>
                                <th width={40}></th>
                                <th width={40}></th>
                                <th>Item</th>
                                <th width={40}>Image</th>
                                <th width={80}>Progress</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderItemRow(sectionIdx, section.items)}
                        </tbody>
                    </table>
                </div>
            ))
    }

    renderNoticeSectionRow() {
        const { noticeSection } = this.state

        if (!_.isEmpty(noticeSection) && noticeSection.items.length !== 0)
            return (
                <div className="section">
                    <div className="section-header">
                        <div className="section-name">Others</div>
                    </div>
                    <table className={`item-table${noticeSection.toggled ? ' toggled' : ''}`}>
                        <thead>
                            <tr>
                                <th width={40}></th>
                                <th width={40}></th>
                                <th>Item</th>
                                <th width={40}>Image</th>
                                <th width={80}>Progress</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderNoticeItemRow(noticeSection.items)}
                        </tbody>
                    </table>
                </div>
            )
    }

    render() {
        const { modalVisible } = this.state

        return (
            <div className="GenerateWPReportModal-wrapper cheer-btn">
        		<Button type="primary" size="large" onClick={this.handleClick}>Generate Report</Button>
	            <Modal
	                width="60%"
	                wrapClassName="GenerateWPReportModal"
	                visible={modalVisible}
	                footer={null}
	                onCancel={this.handleCancel}
	            >
	                <p className="label">Please check the updated items that you want to export:</p>
	                <div className="item-list">
	                    {this.renderSectionRow()}
	                    {this.renderNoticeSectionRow()}
	                </div>
	                <div className="footer">
	                    <Button type="primary" size="large" onClick={this.handleConfirm}>Generate</Button>
	                </div>
	            </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/GenerateWPReportModal/GenerateWPReportModal.js